import { render, staticRenderFns } from "./helpResourceConfig.vue?vue&type=template&id=44e94124"
import script from "./helpResourceConfig.vue?vue&type=script&lang=js"
export * from "./helpResourceConfig.vue?vue&type=script&lang=js"
import style0 from "./helpResourceConfig.vue?vue&type=style&index=0&id=44e94124&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44e94124')) {
      api.createRecord('44e94124', component.options)
    } else {
      api.reload('44e94124', component.options)
    }
    module.hot.accept("./helpResourceConfig.vue?vue&type=template&id=44e94124", function () {
      api.rerender('44e94124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/helpResourceConfig.vue"
export default component.exports